<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && records">
          <table class="table mt-1 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Количество</th>
              <th>Комментарий</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records">
              <td>{{ i + 1 }}</td>
              <td>
                <DrugTitleView
                  :drug="r.drug"
                />
              </td>
              <td>{{ r.qty }}</td>
              <td>
                <!--                <form class="flex align-items-center" @submit.prevent="() => updateStoreComment(r.drug_id)">-->
                <form class="flex align-items-center">
                  <div class="mr-2">
                    <clip-loader
                      v-if="loadingRecord[r.drug_id]"
                      class="text-center"
                      :loading="true"
                      :color="$constants.LOADING_COLOR"
                      size="20px"
                    />
                  </div>
                  <input type="text" @change="updateStoreComment(r.drug_id)" :disabled="loadingRecord[r.drug_id]"
                         placeholder="Комментарий"
                         v-model="r.comments.text" class="form-control">
                </form>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api"
import DrugTitleView from "@/components/drugs/DrugTitleView";

export default {
  components: {DrugTitleView},
  data() {
    return {
      records: null,
      loading: false,
      loadingRecord: {},
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async updateStoreComment(drugId) {
      this.loadingRecord[drugId] = true;
      const record = this.records.find((r) => r.drug_id === drugId);
      const {data} = await api.post('/stores/update', {
        action: 'updateComment',
        record_id: record.id,
        comment: record.comments
      })
      if (data.success) {
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loadingRecord[drugId] = false;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/stores/remainList')
      if (data.success) {
        const loadingRecord = {};
        const records = data.records.reduce((acc, r) => {
          acc.push({...r, title: r.drug.title, comments: r.comments || {}});
          loadingRecord[r.drug_id] = false;
          return acc;
        }, [])
        this.loadingRecord = loadingRecord;
        this.records = _.orderBy(records, 'title');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
table.table td {
  padding: 3px;
}
</style>
